module.exports = __webpack_public_path__ + "img/not-found.8c3d2a79.svg";